if (!window.Eurus) window.Eurus = {};
if (!window.Eurus.loadedScript) window.Eurus.loadedScript = new Set();

if (!window.Eurus.loadedScript.has('gift-express-warning.js')) {
  window.Eurus.loadedScript.add('gift-express-warning.js');

  var registerGiftExpressWarning = function () {
    Alpine.data('xGiftExpressWarning', (variant) => ({
      show: false,
      loading: false,
      removing: false,
      unavailableGifts: [],
      config: window.haomaGiftExpressWarningConfig || {},
      variant: variant || 'inline',
      previousCep: '',
      warnedCepKey: 'haoma-gift-express-warning-cep',
      gateId: 'gift-express-warning-' + (++window.__haomaGiftGateSeq || (window.__haomaGiftGateSeq = 0)),
      gateHeld: false,
      cartChangeTimer: null,

      init() {
        this.previousCep = this.getWarnedCep();

        window.addEventListener('haoma:cep-updated', () => {
          this.onCepUpdated();
        });

        document.addEventListener('eurus:cart:items-changed', () => {
          this.scheduleGiftValidationFromItemsChanged();
        });

        window.addEventListener('eurus:cart:items-changed', () => {
          this.scheduleGiftValidationFromItemsChanged();
        });

        if (this.config.enabled && this.getSavedCep()) {
          this.holdGate();
          this.validateGifts(false);
        }

        this.syncForceStandardFromCart();
      },

      holdGate() {
        if (this.gateHeld) return;
        this.gateHeld = true;
        window.dispatchEvent(new CustomEvent('haoma:popup-gate-hold', { detail: { id: this.gateId } }));
      },

      releaseGate() {
        if (!this.gateHeld) return;
        this.gateHeld = false;
        window.dispatchEvent(new CustomEvent('haoma:popup-gate-release', { detail: { id: this.gateId } }));
      },

      applyForceStandard(on) {
        if (window.haomaExpressAvailability && typeof window.haomaExpressAvailability.setForceStandard === 'function') {
          window.haomaExpressAvailability.setForceStandard(on);
        } else {
          window.haomaForceStandardDelivery = !!on;
        }
      },

      scheduleGiftValidationFromItemsChanged() {
        if (this.cartChangeTimer) {
          clearTimeout(this.cartChangeTimer);
        }
        this.cartChangeTimer = setTimeout(() => {
          this.cartChangeTimer = null;
          this.validateGifts(false);
        }, 0);
      },

      async forceStandardDelivery(on) {
        try {
          await fetch(Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { _entrega_forcada: on ? 'padrao' : '' } })
          });
        } catch (e) {
          /* ignore */
        }
        this.applyForceStandard(on);
      },

      async syncForceStandardFromCart() {
        try {
          var cart = await this.fetchCart();
          this.applyForceStandard(!!(cart.attributes && cart.attributes._entrega_forcada === 'padrao'));
        } catch (e) {
          /* ignore */
        }
      },

      async maybeClearForceStandard(cart) {
        if (cart && cart.attributes && cart.attributes._entrega_forcada === 'padrao') {
          await this.forceStandardDelivery(false);
        }
      },

      getSavedCep() {
        try {
          var raw = localStorage.getItem('haoma-cep-express');
          if (!raw) return '';
          var data = JSON.parse(raw);
          return data && data.cep ? String(data.cep) : '';
        } catch (e) {
          return '';
        }
      },

      getWarnedCep() {
        try {
          return sessionStorage.getItem(this.warnedCepKey) || '';
        } catch (e) {
          return '';
        }
      },

      markCepWarned(cep) {
        this.previousCep = cep;
        try {
          sessionStorage.setItem(this.warnedCepKey, String(cep || ''));
        } catch (e) {
          /* ignore */
        }
      },

      // Fora da página /cart o aviso é um modal bloqueante: ele só pode abrir
      // sozinho quando o CEP muda, senão reaparece a cada navegação.
      canAutoShow(cep) {
        if (this.variant !== 'popup') return true;
        return String(cep || '') !== this.getWarnedCep();
      },

      getDismissState(cart, cep) {
        var skus = [];
        var gifts = this.getGiftLineItems(cart);
        for (var i = 0; i < gifts.length; i++) {
          var sku = String(gifts[i].sku);
          if (skus.indexOf(sku) < 0) skus.push(sku);
        }
        return { cep: String(cep || ''), skus: skus.sort() };
      },

      // A dispensa continua valendo enquanto o cliente só mexe na quantidade ou
      // remove itens: o aviso só volta com um brinde novo ou outro CEP.
      isDismissed(state) {
        try {
          var raw = sessionStorage.getItem(this.config.dismissStorageKey || 'haoma-gift-express-warning-dismissed');
          if (!raw) return false;
          var saved = JSON.parse(raw);
          if (!saved || saved.cep !== state.cep || !saved.skus || !saved.skus.length) return false;
          for (var i = 0; i < state.skus.length; i++) {
            if (saved.skus.indexOf(state.skus[i]) < 0) return false;
          }
          return true;
        } catch (e) {
          return false;
        }
      },

      persistDismiss(state) {
        try {
          sessionStorage.setItem(
            this.config.dismissStorageKey || 'haoma-gift-express-warning-dismissed',
            JSON.stringify({ cep: state.cep, skus: state.skus, dismissedAt: Date.now() })
          );
        } catch (e) {
          /* ignore */
        }
      },

      async fetchCart() {
        var response = await fetch(Shopify.routes.root + 'cart.js', {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('cart');
        return response.json();
      },

      getGiftLineItems(cart) {
        return (cart.items || []).filter(function (item) {
          if (!item || !item.sku) return false;
          return item.properties && item.properties._gift === 'true';
        });
      },

      async checkAvailability(skus) {
        if (!window.haomaExpressAvailability || typeof window.haomaExpressAvailability.check !== 'function') {
          return {};
        }
        return window.haomaExpressAvailability.check(skus);
      },

      sectionIds() {
        if (window.Alpine && Alpine.store('xCartHelper')) {
          return Alpine.store('xCartHelper').getSectionsToRender().map(function (s) {
            return s.id;
          });
        }
        return [];
      },

      async validateGifts(force) {
        if (!this.config.enabled) {
          this.show = false;
          this.releaseGate();
          return;
        }

        var cep = this.getSavedCep();
        if (!cep) {
          this.show = false;
          this.releaseGate();
          return;
        }

        var canAutoShow = this.canAutoShow(cep);

        this.holdGate();
        this.loading = true;

        try {
          var cart = await this.fetchCart();
          var gifts = this.getGiftLineItems(cart);
          if (!gifts.length) {
            this.markCepWarned(cep);
            this.show = false;
            this.unavailableGifts = [];
            await this.maybeClearForceStandard(cart);
            this.releaseGate();
            return;
          }

          var skus = gifts.map(function (item) {
            return String(item.sku);
          });
          var availability = await this.checkAvailability(skus);
          var unavailable = gifts
            .filter(function (item) {
              return availability[String(item.sku)] !== true;
            })
            .map(function (item) {
              return {
                key: item.key,
                sku: item.sku,
                marco: item.properties && item.properties._marco != null ? String(item.properties._marco) : '',
                title: item.product_title || item.title,
                image: item.image || (item.featured_image && item.featured_image.url) || ''
              };
            });

          this.markCepWarned(cep);

          if (!unavailable.length) {
            this.show = false;
            this.unavailableGifts = [];
            await this.maybeClearForceStandard(cart);
            this.releaseGate();
            return;
          }

          if (!force && this.isDismissed(this.getDismissState(cart, cep))) {
            this.show = false;
            this.unavailableGifts = [];
            this.releaseGate();
            return;
          }

          if (!force && !canAutoShow) {
            this.show = false;
            this.unavailableGifts = [];
            this.releaseGate();
            return;
          }

          this.unavailableGifts = unavailable;
          this.show = true;
        } catch (e) {
          this.releaseGate();
          /* fail silently */
        } finally {
          this.loading = false;
        }
      },

      onCepUpdated() {
        var newCep = this.getSavedCep();
        if (!newCep || newCep === this.previousCep) return;

        this.holdGate();

        var self = this;
        setTimeout(function () {
          self.forceStandardDelivery(false).then(function () {
            return self.restoreOptedOutGifts();
          }).then(function () {
            self.validateGifts(true);
          });
        }, 350);
      },

      waitForReconcile(maxWait) {
        return new Promise(function (resolve) {
          var start = Date.now();
          (function check() {
            var elapsed = Date.now() - start;
            if (!window.__hbReconciling && elapsed > 500) return resolve();
            if (elapsed > (maxWait || 4000)) return resolve();
            setTimeout(check, 150);
          })();
        });
      },

      async restoreOptedOutGifts() {
        try {
          var cart = await this.fetchCart();
          var attrs = cart.attributes || {};
          var clear = {};
          var found = false;
          for (var key in attrs) {
            if (/^_brinde_optout_\d+$/.test(key) && attrs[key]) {
              clear[key] = '';
              found = true;
            }
          }
          if (!found) return;

          window.updatingCart = true;
          await fetch(Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: clear })
          });
          window.updatingCart = false;

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          window.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));

          await this.waitForReconcile(4000);

          if (window.Alpine && Alpine.store('xCartHelper')) {
            await Alpine.store('xCartHelper').reRenderSections(null);
          }
        } catch (e) {
          window.updatingCart = false;
        } finally {
          if (window.Alpine && Alpine.store('xMiniCart')) {
            Alpine.store('xMiniCart').loading = false;
          }
        }
      },

      async keep() {
        var cep = this.getSavedCep();
        try {
          var cart = await this.fetchCart();
          this.persistDismiss(this.getDismissState(cart, cep));
          await this.forceStandardDelivery(true);
        } catch (e) {
          /* ignore */
        }
        this.markCepWarned(cep);
        this.show = false;
        this.releaseGate();
      },

      async removeGift() {
        if (this.removing || !this.unavailableGifts.length) return;
        if (!this.config.allowRemove) return;

        this.removing = true;
        var sections = this.sectionIds();
        var lastSections = null;

        try {
          window.updatingCart = true;

          // O opt-out guarda o CEP que o gerou: a reconciliação só o respeita
          // enquanto o CEP salvo for esse. Mudou o CEP, o brinde pode voltar.
          var optOutCep = this.getSavedCep() || 'true';
          var optOutAttributes = {};
          for (var i = 0; i < this.unavailableGifts.length; i++) {
            var gift = this.unavailableGifts[i];
            if (gift.marco) {
              optOutAttributes['_brinde_optout_' + gift.marco] = optOutCep;
            }
          }

          if (Object.keys(optOutAttributes).length) {
            await fetch(Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ attributes: optOutAttributes })
            });
          }

          for (var j = 0; j < this.unavailableGifts.length; j++) {
            var body = {
              id: this.unavailableGifts[j].key,
              quantity: 0
            };
            if (sections.length) {
              body.sections = sections;
              body.sections_url = window.location.pathname;
            }
            var response = await fetch(Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body)
            });
            if (response.ok) {
              var parsed = await response.json();
              if (parsed && parsed.sections) lastSections = parsed.sections;
            }
          }

          if (lastSections && window.Alpine && Alpine.store('xCartHelper')) {
            await Alpine.store('xCartHelper').reRenderSections(lastSections);
          }

          this.unavailableGifts = [];
          this.show = false;
          this.releaseGate();

          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          window.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        } catch (e) {
          /* fail silently */
        } finally {
          window.updatingCart = false;
          // O drawer esconde a lista enquanto o mini carrinho está em loading:
          // deixar essa flag presa faria os itens sumirem até um recarregamento.
          if (window.Alpine && Alpine.store('xMiniCart')) {
            Alpine.store('xMiniCart').loading = false;
          }
          this.removing = false;
        }
      }
    }));
  };

  if (window.Alpine) {
    registerGiftExpressWarning();
  } else {
    document.addEventListener('alpine:init', registerGiftExpressWarning);
  }
}
